module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point4_1-adbb051a4cbee0e894e781954c61a578.jpg";